"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TablePagination", {
    enumerable: true,
    get: function() {
        return TablePagination;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Text = require("../Text/Text");
const _ri = require("react-icons/ri");
const _Form = require("../Form");
const _AdminButton = require("../Button/AdminButton");
const _localisationeq1 = require("@equiem/localisation-eq1");
const _contexts = require("../../contexts");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const TablePagination = (param)=>{
    let { totalCount, currentPage, pageSize, onPageChange } = param;
    const { t } = (0, _localisationeq1.useTranslation)();
    const { colors, breakpoints } = (0, _contexts.useTheme)();
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "35a4ee954ed6e2cc",
                [
                    colors.grayscale[60],
                    breakpoints.md
                ]
            ]
        ]) + " " + "pagination"
    }, /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "label"
    }, t("common.xOfYResults", {
        x: "".concat(currentPage * pageSize - pageSize + 1, "-").concat(Math.min(totalCount, currentPage * pageSize)),
        y: totalCount
    })), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "35a4ee954ed6e2cc",
                [
                    colors.grayscale[60],
                    breakpoints.md
                ]
            ]
        ]) + " " + "arrows"
    }, /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        variant: "outline",
        shape: "round",
        disabled: currentPage === 1,
        onClick: ()=>onPageChange(currentPage - 1, pageSize),
        className: "page-prev"
    }, /*#__PURE__*/ _react.default.createElement(_ri.RiArrowLeftSLine, {
        size: 16
    })), /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        variant: "outline",
        shape: "round",
        disabled: currentPage === Math.ceil(totalCount / pageSize) || totalCount < pageSize,
        onClick: ()=>onPageChange(currentPage + 1, pageSize),
        className: "page-next"
    }, /*#__PURE__*/ _react.default.createElement(_ri.RiArrowRightSLine, {
        size: 16
    }))), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "35a4ee954ed6e2cc",
                [
                    colors.grayscale[60],
                    breakpoints.md
                ]
            ]
        ]) + " " + "page-size"
    }, /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "label"
    }, t("common.resultsPerPage")), /*#__PURE__*/ _react.default.createElement(_Form.Select, {
        value: pageSize.toString(),
        onChange: (e)=>onPageChange(1, parseInt(e.target.value, 10))
    }, [
        20,
        50,
        100
    ].map((value)=>/*#__PURE__*/ _react.default.createElement("option", {
            key: value,
            value: value,
            className: _style.default.dynamic([
                [
                    "35a4ee954ed6e2cc",
                    [
                        colors.grayscale[60],
                        breakpoints.md
                    ]
                ]
            ])
        }, value)))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "35a4ee954ed6e2cc",
        dynamic: [
            colors.grayscale[60],
            breakpoints.md
        ]
    }, ".pagination.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin-top:16px;color:".concat(colors.grayscale[60], "}.pagination.__jsx-style-dynamic-selector .arrows.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:4px}.pagination.__jsx-style-dynamic-selector .page-size.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:8px;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;white-space:nowrap}@media(max-width:").concat(breakpoints.md, "px){.pagination.__jsx-style-dynamic-selector .page-size.__jsx-style-dynamic-selector{display:none}}")));
};

//# sourceMappingURL=TablePagination.js.map